export const UI_PROFILES = [
  { value: 'baidao', label: '百道新版', description: '统一框架、列表与单据视觉' },
  { value: 'legacy', label: '经典界面', description: '保留改造前视觉，可随时回退' }
]

export const UI_THEMES = [
  { value: 'meteor-blue', label: '流星蓝', color: '#2563eb' },
  { value: 'ice-blue', label: '冰川蓝', color: '#0891b2' },
  { value: 'coast-blue', label: '海岸蓝', color: '#0369a1' },
  { value: 'jewel-green', label: '宝石绿', color: '#059669' },
  { value: 'stardust-purple', label: '星尘紫', color: '#7c3aed' },
  { value: 'lava-orange', label: '熔岩橙', color: '#ea580c' },
  { value: 'glow-red', label: '炽光红', color: '#dc2626' },
  { value: 'business-gray', label: '商务灰', color: '#475569' }
]

export const DEFAULT_UI_PROFILE = 'baidao'
export const DEFAULT_UI_THEME = 'meteor-blue'
